/*
  Fills and times the scrolling promo strip.

  The CSS animates the track to -50%, which only loops seamlessly if the track is exactly two
  identical halves. Liquid prints one group; how many copies a half needs depends on how wide that
  group renders and how wide the screen is, and neither is known until the browser has laid it out.
  So the cloning happens here.

  Duration is derived rather than set: a fixed duration would make a short strip crawl and a long one
  race, because the same seconds cover a different distance. Speed is px/second, and the lap time
  falls out of the distance one half travels.
*/
(function () {
  'use strict';

  var SPEEDS = { slow: 30, medium: 55, fast: 90 };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(root) {
    var viewport = root.querySelector('[data-marquee-viewport]');
    var track = root.querySelector('[data-marquee-track]');
    if (!viewport || !track) return;

    var original = track.querySelector('[data-marquee-group]');
    if (!original) return;

    // Someone who has asked for less motion gets the row as it is: readable, swipeable, still.
    // Cloning would only leave them looking at the same promo four times over.
    if (prefersReducedMotion()) {
      root.classList.remove('is-ready');
      return;
    }

    // Start from one group every time, so a resize recomputes rather than compounding.
    var groups = track.querySelectorAll('[data-marquee-group]');
    for (var i = groups.length - 1; i > 0; i--) groups[i].parentNode.removeChild(groups[i]);
    original.removeAttribute('aria-hidden');

    var groupWidth = original.getBoundingClientRect().width;
    var viewportWidth = viewport.getBoundingClientRect().width;
    if (!groupWidth || !viewportWidth) return;

    // A half has to be at least as wide as the strip, or the tail end of the loop shows empty
    // space before the next copy arrives.
    var copies = Math.max(1, Math.ceil(viewportWidth / groupWidth));

    var fragment = document.createDocumentFragment();
    // 2 * copies total: the first `copies` are the half that is read, the rest are the duplicate
    // the -50% translate lands on. Only the originals are exposed to assistive tech.
    for (var c = 0; c < copies * 2 - 1; c++) {
      var clone = original.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      // The duplicates are decoration; a keyboard user should not tab through the same five
      // promos four more times.
      Array.prototype.forEach.call(clone.querySelectorAll('a'), function (link) {
        link.setAttribute('tabindex', '-1');
      });
      fragment.appendChild(clone);
    }
    track.appendChild(fragment);

    var speed = SPEEDS[root.getAttribute('data-speed')] || SPEEDS.medium;
    var halfWidth = groupWidth * copies;
    track.style.setProperty('--marquee-duration', halfWidth / speed + 's');

    root.classList.add('is-ready');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-promo-marquee]'), function (root) {
      setup(root);

      var timer = null;
      var lastWidth = window.innerWidth;
      window.addEventListener(
        'resize',
        function () {
          // Mobile browsers fire resize when the address bar hides, which changes height only.
          // Rebuilding on that would restart the animation mid-scroll for no reason.
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          if (timer) window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            setup(root);
          }, 200);
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // The theme editor re-renders a section in place; without this the new markup never gets measured.
  document.addEventListener('shopify:section:load', boot);
})();
